import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/call.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/color/botim-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/color/telegram-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/color/viber-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/color/wechat-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/color/whats-app-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/communication/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/content/property/stage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ae.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/es.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/fr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ge.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/gr.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/countries/ua.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/eur.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/currency/usd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/controls/location-pin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/ui/forms/email.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ModalLayout"] */ "/app/src/components/ui/Common/Layouts/modalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Common/Logo/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Footer/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/GoldenVisa/GoldenVisaMainHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/components/ui/Header/HeaderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageChanger"] */ "/app/src/components/ui/LanguageChanger/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Location"] */ "/app/src/components/ui/Location/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocationState"] */ "/app/src/components/ui/LocationInit/Location.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavoriteProvider"] */ "/app/src/providers/FavoriteContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewProvider"] */ "/app/src/providers/ViewContext.tsx");
